import React from "react";
import { Outlet } from "react-router-dom";
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { DISABLE_BUGSNAG } from "@/core/variables";
import ErrorFallback from "./ErrorFallback";


Bugsnag.start({
    onError: () => {
        return !DISABLE_BUGSNAG;
    },
    apiKey: "86de7374abe2270cf12d23864fc26427",
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ["production"]
});

const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);

const ErrorBoundaryLayout: React.FC = () => {
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Outlet />
        </ErrorBoundary>
    );
};

export default ErrorBoundaryLayout;
